// Mock data for Pankaj Vinod Fulwani Author Website

export const authorData = {
  name: "Pankaj Vinod Fulwani",
  title: "Author, Social Worker & RSS Volunteer",
  bio: "Pankaj Vinod Fulwani is a dedicated author, social worker, and passionate volunteer with Rashtriya Swayamsevak Sangh. With a vision to contribute to Viksit Bharat 2047, he works tirelessly towards nation-building through service, culture, and organization.",
  mission: "To inspire and mobilize the youth of India towards building a developed, self-reliant, and culturally rooted Bharat by 2047.",
  image: "https://images.unsplash.com/photo-1758336011136-343678e4fc05?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBhdXRob3IlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODUxNjExODl8MA&ixlib=rb-4.1.0&q=85",
  email: "contact@pankajfulwani.com",
  phone: "+91 98765 43210",
  whatsapp: "+919876543210",
  social: {
    facebook: "https://facebook.com/pankajfulwani",
    twitter: "https://twitter.com/pankajfulwani",
    instagram: "https://instagram.com/pankajfulwani",
    linkedin: "https://linkedin.com/in/pankajfulwani",
    youtube: "https://youtube.com/@pankajfulwani"
  }
};

export const bookData = {
  title: "राष्ट्रीय स्वयंसेवक संघ : नवभारत का शंखनाद",
  titleEnglish: "Rashtriya Swayamsevak Sangh: Navbharat Ka Shankhnaad",
  subtitle: "एक पुस्तक... एक विचार... एक संकल्प... विकसित भारत 2047 की ओर",
  description: "यह पुस्तक राष्ट्रीय स्वयंसेवक संघ के इतिहास, दर्शन और देश निर्माण में उसकी भूमिका पर एक गहन और प्रेरक अध्ययन है। इसमें संघ के संस्थापक, विचारधारा, कार्यप्रणाली और विकसित भारत 2047 के सपने को साकार करने में संघ के योगदान का विस्तृत वर्णन है।",
  coverImage: "https://images.unsplash.com/photo-1519764340700-3db40311f21e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxib29rJTIwbW9ja3VwfGVufDB8fHx8MTc4NTE2MTE4OXww&ixlib=rb-4.1.0&q=85",
  isbn: "9789347691034",
  pages: 256,
  language: "Hindi",
  publisher: "Garuda Prakashan",
  publishDate: "2024",
  price: "₹350",
  buyLinks: {
    amazon: "https://amzn.in/d/0ihDNFj3",
    flipkart: "https://www.flipkart.com/product/p/itme?pid=9789347691034",
    garudaIndia: "https://garudalife.in/rashtriya-swayamsevak-sangh-navbharat-ka-shankhnaad",
    garudaInternational: "https://garudalife.com/rashtriya-swayamsevak-sangh-navbharat-ka-shankhnaad"
  },
  highlights: [
    "संघ की स्थापना और विकास की कहानी",
    "राष्ट्र निर्माण में संघ का योगदान",
    "पंच परिवर्तन का दर्शन",
    "विकसित भारत 2047 का रोडमैप",
    "समाज समरसता और संगठन की शक्ति",
    "सेवा और संस्कार का महत्व"
  ],
  tableOfContents: [
    "अध्याय 1: संघ की स्थापना और प्रेरणा",
    "अध्याय 2: संघ का संगठन और कार्यप्रणाली",
    "अध्याय 3: राष्ट्रीय चरित्र निर्माण",
    "अध्याय 4: सामाजिक समरसता",
    "अध्याय 5: पंच परिवर्तन का दर्शन",
    "अध्याय 6: विकसित भारत 2047",
    "अध्याय 7: युवा शक्ति और राष्ट्र निर्माण",
    "अध्याय 8: संघ की वैश्विक उपस्थिति"
  ]
};

export const statsData = {
  readers: 50000,
  reviews: 1200,
  events: 150,
  rating: 4.8
};

export const reviewsData = [
  {
    id: 1,
    name: "डॉ. राजेश शर्मा",
    designation: "प्रोफेसर, राजनीति विज्ञान",
    review: "यह पुस्तक संघ के बारे में एक संतुलित और गहन अध्ययन प्रस्तुत करती है। हर भारतीय को यह अवश्य पढ़नी चाहिए।",
    rating: 5,
    image: "https://images.unsplash.com/photo-1617009762269-c062aaf6b3a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxib29rJTIwcmVhZGluZyUyMGluZGlhfGVufDB8fHx8MTc4NTE2MTI0OXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    name: "सुनीता पाटिल",
    designation: "सामाजिक कार्यकर्ता",
    review: "पंकज जी ने बहुत ही सरल और प्रभावी भाषा में संघ के कार्यों को प्रस्तुत किया है। प्रेरणादायक!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1488868041904-34e7810c8bff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxib29rJTIwcmVhZGluZyUyMGluZGlhfGVufDB8fHx8MTc4NTE2MTI0OXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    name: "अमित वर्मा",
    designation: "उद्यमी",
    review: "विकसित भारत 2047 के सपने को समझने के लिए यह पुस्तक एक अद्भुत मार्गदर्शक है।",
    rating: 5,
    image: "https://images.unsplash.com/photo-1585607344893-43a4bd91169a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBjZWxlYnJhdGlvbnxlbnwwfHx8fDE3ODUxNjEyNDl8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    name: "प्रीति देशमुख",
    designation: "शिक्षिका",
    review: "युवाओं के लिए यह पुस्तक अत्यंत महत्वपूर्ण है। राष्ट्र निर्माण का सही मार्ग दिखाती है।",
    rating: 5,
    image: "https://images.unsplash.com/photo-1520312622401-cac590a0d473?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBjZWxlYnJhdGlvbnxlbnwwfHx8fDE3ODUxNjEyNDl8MA&ixlib=rb-4.1.0&q=85"
  }
];

export const galleryData = [
  {
    id: 1,
    title: "Book Launch Event",
    image: "https://images.unsplash.com/photo-1617009762269-c062aaf6b3a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxib29rJTIwcmVhZGluZyUyMGluZGlhfGVufDB8fHx8MTc4NTE2MTI0OXww&ixlib=rb-4.1.0&q=85",
    category: "events"
  },
  {
    id: 2,
    title: "Reader Engagement",
    image: "https://images.unsplash.com/photo-1488868041904-34e7810c8bff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxib29rJTIwcmVhZGluZyUyMGluZGlhfGVufDB8fHx8MTc4NTE2MTI0OXww&ixlib=rb-4.1.0&q=85",
    category: "readers"
  },
  {
    id: 3,
    title: "Media Coverage",
    image: "https://images.unsplash.com/photo-1523995462485-3d171b5c8fa9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHw0fHxuZXdzcGFwZXIlMjBwcmVzc3xlbnwwfHx8fDE3ODUxNjEyNDl8MA&ixlib=rb-4.1.0&q=85",
    category: "media"
  },
  {
    id: 4,
    title: "Press Release",
    image: "https://images.unsplash.com/photo-1504711434969-e33886168f5c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxuZXdzcGFwZXIlMjBwcmVzc3xlbnwwfHx8fDE3ODUxNjEyNDl8MA&ixlib=rb-4.1.0&q=85",
    category: "media"
  },
  {
    id: 5,
    title: "Community Event",
    image: "https://images.unsplash.com/photo-1585607344893-43a4bd91169a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBjZWxlYnJhdGlvbnxlbnwwfHx8fDE3ODUxNjEyNDl8MA&ixlib=rb-4.1.0&q=85",
    category: "events"
  },
  {
    id: 6,
    title: "Cultural Gathering",
    image: "https://images.unsplash.com/photo-1520312622401-cac590a0d473?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBjZWxlYnJhdGlvbnxlbnwwfHx8fDE3ODUxNjEyNDl8MA&ixlib=rb-4.1.0&q=85",
    category: "events"
  }
];

export const videosData = [
  {
    id: 1,
    title: "Book Introduction by Author",
    embedUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    thumbnail: "https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg"
  },
  {
    id: 2,
    title: "Interview on Nation Building",
    embedUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    thumbnail: "https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg"
  },
  {
    id: 3,
    title: "Book Launch Highlights",
    embedUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    thumbnail: "https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "पंच परिवर्तन: राष्ट्र निर्माण का आधार",
    excerpt: "राष्ट्र निर्माण के लिए पंच परिवर्तन - व्यक्ति, परिवार, समाज, राष्ट्र और विश्व में सकारात्मक परिवर्तन लाना आवश्यक है।",
    date: "15 जनवरी 2025",
    image: "https://images.unsplash.com/photo-1635438747567-8244074a3180?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBmbGFnfGVufDB8fHx8MTc4NTE2MTIwNXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "विकसित भारत 2047: एक दृष्टि",
    excerpt: "2047 तक भारत को विकसित राष्ट्र बनाने के लिए युवा शक्ति, तकनीक और संस्कृति का समन्वय आवश्यक है।",
    date: "10 जनवरी 2025",
    image: "https://images.unsplash.com/photo-1597058712635-3182d1eacc1e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjBmbGFnfGVufDB8fHx8MTc4NTE2MTIwNXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "सेवा और संस्कार: जीवन का मूल मंत्र",
    excerpt: "समाज सेवा और संस्कारित जीवन ही राष्ट्र की वास्तविक शक्ति हैं। युवाओं को इस दिशा में आगे आना चाहिए।",
    date: "5 जनवरी 2025",
    image: "https://images.unsplash.com/photo-1548013146-72479768bada?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxpbmRpYSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODUxNjExOTl8MA&ixlib=rb-4.1.0&q=85"
  }
];

export const manifestoChapters = [
  {
    number: "01",
    title: "सेवा",
    titleEnglish: "SEVA",
    description: "समाज सेवा राष्ट्र निर्माण का प्रथम स्तंभ है"
  },
  {
    number: "02",
    title: "संस्कार",
    titleEnglish: "SANSKAR",
    description: "संस्कार से ही चरित्र निर्माण होता है"
  },
  {
    number: "03",
    title: "समरसता",
    titleEnglish: "SAMARASATA",
    description: "समाज में समरसता लाना आवश्यक है"
  },
  {
    number: "04",
    title: "संगठन",
    titleEnglish: "SANGATHAN",
    description: "संगठन में ही शक्ति है"
  },
  {
    number: "05",
    title: "पंच परिवर्तन",
    titleEnglish: "PANCH PARIVARTAN",
    description: "व्यक्ति से विश्व तक सकारात्मक परिवर्तन"
  }
];